// extracted by mini-css-extract-plugin
export default {"refund-details":"RefundRequest_refund-details__5JTam"};